import { UserResponse } from "./UserReponse";

export interface ITokenResponse {
    token?: string | undefined;
    refreshToken?:string|undefined;
    user:UserResponse|undefined;
  }

  export class TokenResponse implements ITokenResponse {
    token?: string | undefined;
    refreshToken?:string|undefined;
    user:UserResponse|undefined;
  
    constructor(data?: ITokenResponse) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  
    init(_data?: any) {
      if (_data) {
        this.token = _data["token"];
        this.refreshToken = _data["refreshToken"];
        this.user = _data["user"] ? UserResponse.fromJS(_data["user"]): <any>undefined;
        
      }
    }
  
    static fromJS(data: any): TokenResponse {
      data = typeof data === "object" ? data : {};
      let result = new TokenResponse();
      result.init(data);
      return result;
    }
  
    toJSON(data?: any) {
      data = typeof data === "object" ? data : {};
      data["token"] = this.token;
      data["refreshToken"] = this.refreshToken;
      data["user"] = this.user ? this.user.toJSON() : <any>undefined;
      return data;
      
    }
  }